import { toArray } from '@assess/shared/type-utilities';

import { isPresent } from './is-present';
import { processSearchBody } from './process-search-body';
import { PostBody, PostBodyFilter } from '../types/post-body.types';
import { SearchBody } from '../types/search-body.types';

export const convertToPostSearchBody = (searchBody: SearchBody | undefined) => {
  const processed = processSearchBody(searchBody);
  const { filters, ...rest } = processed;

  return {
    ...rest,
    filters: convertFilters(filters),
  } as PostBody;
};

const convertFilters = (filters: SearchBody['filters'] | undefined) => {
  return !filters
    ? filters
    : Object.entries(filters)
        .filter(([key, _value]) => isPresent(key))
        .filter(([_key, value]) => isPresent(value))
        .reduce((acc: PostBodyFilter[], entry: any) => {
          const [field, values] = entry;

          return [...acc, { field, values: toArray(values) }];
        }, [] as PostBodyFilter[]);
};
